module.exports = {
    alerts: {
        deleteFile: "Ви впевнені, що хочете видалити цей файл?",
        error: "Помилка",
        success: "Успішно",
        warning: "Увага",
        unknownError: "Невідома помилка",
        fileNotFound: "Файл не знайдено!",
        fileNotUploaded: "Файл не завантажено!",
        fileNotDeleted: "Файл не видалено!",
        newAccessRequestTitle: "Новий запит на доступ!",
        newAccessRequestBody: "Дистриб'ютор хоче отримати доступ до клієнта"
    },
    asks: {
        warning: "Увага",
        confirmCuttingTitle: "Відправити на порізку?",
        confirmCuttingText: "Замовлення буде переміщено в \"Нові\" і всі складальники отримають сповіщення.",
        confirmCuttingDoneTitle: "Завершити порізку?",
        confirmCuttingDoneText: "Замовленню буде встановлено статус \"Завершено\".",
        delete_status: "Ви дійсно хочете видалити статус користувача",
        confirmTakeOrder: "Ви дійсно бажаєте взяти замовлення в роботу?",
        confirmWasCutReminder: "Ви переводите статус на 'Завершено', але не натиснули кнопку 'Викрійку порізано'. Лекало не буде відмічене як порізане. Все одно продовжити?",
        deleteUser: "Ви впевнені, що хочете видалити користувача?",
        confirmClone: "Ви дійсно хочете клонувати це замовлення?",
        delete_file: "Ви впевнені, що хочете видалити цей файл?",
        deleteCut: "Дійсно видалити відрізок?",
        deleteNoteTitle: "Видалити примітку?",
        requestNoteDeletionTitle: "Надіслати запит на видалення?",
        requestNoteDeletionText: "Примітку буде видалено після підтвердження адміністратором."
    },
    buttons: {
        clearFilter: "Очистити",
        reply: "Відповісти",
        reaction: "Реакція",
        sendAccessRequest: "Надіслати запит на доступ",
        reloadPage: "Перезавантажити сторінку",
        recordAudioNote: "Записати голосове повідомлення",
        stopRecording: "Зупинити запис",
        stop: "Стоп",
        sendToCutting: "Відправити на порізку",
        cuttingDone: "Викрійку порізано (Завершити)",
        imHere: "Я тут!",
        clearStatus: "Скинути статус",
        addStatus: "Додати статус",
        add: "Додати",
        addClient: "Додати клієнта",
        addNote: "Додати примітку",
        acknowledged: "Ознайомився",
        addOrder: "Додати замовлення",
        addUser: "Додати користувача",
        apply: "Застосувати",
        cancel: "Відміна",
        confirm: "Підтвердити",
        delete: "Видалити",
        deleteClient: "Видалити клієнта",
        deleteOrder: "Видалити замовлення",
        edit: "Редагування",
        editOrder: "Редагувати замовлення",
        logoutBtn: "Вийти",
        show: "Показати",
        hide: "Сховати",
        send: "Надіслати",
        save: "Зберегти",
        subscribeUser: "Підписатися на сповіщення",
        takeToWork: "В роботу",
        unsubcribeUser: "Відписатися від сповіщень",
        update: "Оновити",
        clone: "Клонувати",
        downloadAllCuts: 'Завантажити всі відрізки',
        loading: "Завантаження...",
        selectPatterns: "Вибрати лекала з бази"
    },
    days: {
        friday: "Пт",
        monday: "Пн",
        saturday: "СБ",
        sunday: "Нд",
        thursday: "Чт",
        tuesday: "Вт",
        wednesday: "Ср"
    },
    errors: {
        notificationNotSupported: "Ваш браузер не підтримує сповіщення",
        serviceWorkerNotSupported: "Ваш браузер не підтримує Service Worker",
        pushManagerNotSupported: "Ваш браузер не підтримує push-сповіщення",
        notificationPermissionRequired: "Потрібен дозвіл на показ сповіщень",
        serviceWorkerTimeout: "Таймаут завантаження Service Worker",
        subscriptionFailed: "Не вдалося підписатися",
        unsubscribeFailed: "Не вдалося відписатися",
        notificationRequestPermission: "Дозвіл на сповіщення не надано",
        subcriptionToServer: "Помилка при підписці на сповіщення:",
        user_already_exists: "Користувач вже існує",
        invalid_request: "Невірний запит",
        user_not_found: "Користувача не знайдено",
        user_updated: "Користувача успішно оновлено",
        wrong_password: "Невірний пароль",
        invalid_data: "Невірні дані",
        access_denied: "У вас немає доступу до цієї функції",
        invalid_token: "Невірний токен",
        not_found: "Запис не знайдено",
        create_failed: "Помилка створення",
        update_failed: "Помилка оновлення",
        delete_failed: "Помилка видалення",
        unknown_error: "Невідома помилка",
        order_delete_failed: "Не вдалося видалити замовлення!"
    },
    headings: {
        draftsmenStats: "Статистика складальників",
        anomalousSessions: "Аномальні сесії (≥ 8 год)",
        completedOrders: "Завершені замовлення",
        clientOrder: "Замовлення клієнта",
        newOrders: "Нові замовлення",
        orderData: "Дані замовлення",
        carData: "Автомобіль",
        statusSection: "Статус та наявність лекал",
        actors: "Клієнт та менеджер",
        ordersForPeriod: "Замовлення за період",
        ordersInProgress: "Замовлення в роботі"
    },
    labels: {
        replyPhoto: "Фото",
        replyVideo: "Відео",
        replyVoice: "Голосове повідомлення",
        replyMedia: "Медіа",
        replyUser: "Користувач",
        replyTo: "Відповідь для",
        editMessage: "Редагування повідомлення",
        clientOwner: "Клієнт Дистрибютора",
        clientNotes: "Примітки клієнта",
        clientNote: "Примітка клієнта",
        problemPattern: "Проблемна викрійка",
        problemPackaging: "Проблема упаковки",
        wasCut: "Лекало різалось",
        hasNoPatterns: "Немає лекал",
        patternRequestSent: "Відправлено запит на отримання лекал",
        noPatternsSelectStatus: "Оберіть статус відсутності лекал",
        noPatternsNoneInAny: "Немає лекал в жодній з баз",
        noPatternsNoneInOurs: "Немає лекал в наших базах",
        noPatternsPartial: "Є лекала частково",
        noPatternsPartialBadge: "Є частково",
        assemblyProgram: "Програма збірки лекала",
        assemblyProgramSelect: "Оберіть програму збірки",
        assemblyProgramHint: "Можна обрати кілька. Програми з відрізків підтягуються автоматично й керуються у відрізках.",
        assemblyProgramLocked: "Обрано на відрізку — змінюється у відрізках",
        assembledIn: "Зібрано у програмі",
        filterNoPatternsAllOrders: "Лекала: всі замовлення",
        filterNoPatternsAny: "Немає лекал (всі)",
        filterNoPatternsPartial: "Є лекала частково",
        filterNoPatternsLabel: "Наявність лекал",
        filterAssemblyProgramAll: "Програма збірки: всі",
        unknown:"Невідомо",
        unknownModel:"Не знаю моделі/року або немає моделі",
        manualTitle: "Ввести назву вручну",
        pattern: "Лекало",
        files: "Файли",
        accessTo: "Доступ до",
        created: "Створено",
        processed: "Оброблено",
        waitingConfirmation: "Очікує підтвердження",
        listened: "Прослухали",
        audioNotes: "Голосові повідомлення",
        cutting: "Порізка",
        statusName: "Назва статусу",
        statusColor: "Колір статусу",
        statusRole: "Для якої ролі статус",
        setStatus: "Статус",
        onlineUsers: "Хто в мережі",
        addAutomatically: "Буде додано автоматично",
        addCutToOrder: "Додати кусок плівки до замовлення",
        order_deleted: "Видалення замовлення",
        toWorkPt1: "Замовлення",
        toWorkPt2: "взято в роботу",
        carPhotos: "Фото авто",
        customPeriod: "Період",
        editCut: "Редагувати кусок",
        filmLength: "Довжина плівки",
        filmWidth: "Ширина плівки",
        filmCutsForOrder: "Відрізки плівки для замовлення",
        isActiveUser: "Користувач активний",
        orderFiles: "Файли для замовлення",
        orders: "Замовлення",
        orderViewedBy: "Замовлення переглядають:",
        orderStatus: "Статус замовлення",
        orderFromDistributor: "Замовлення від дистриб'ютора",
        phone: "Телефон",
        shortDescription: "Короткий опис",
        lastUpdate: "Останнє оновлення",
        totalFilmArea: "Загальна площа плівки",
        userGroup: "Група користувача",
        urgent: "Терміново!",
        changeHistory: "Історія змін",
        badge: "Бейдж",
        translations: "Переклади",
        select_value: "Оберіть значення"
    },
    messages: {
        downloadingPatterns: "Завантажуємо лекала на сервер...",
        selectModelOrCheckUnknown:"Будь ласка, оберіть модель і рік автомобіля, або поставте галочку \"Не знаю моделі/року\".",
        accessRequestSent: "Запит успішно надіслано! Очікуйте підтвердження.",
        nothingFound: "Нічого не знайдено",
        cutsSaving: "Збереження лекал…",
        cutsSaved: "Лекала збережено",
        cutsSaveError: "Не вдалося зберегти лекала",
        anomalyExcluded: "Сесії ≥ 8 год не враховуються в робочому часі",
        carChangedDeletePatterns: "Ви вибрали іншу модель. Попередні лекала будуть видалені. Продовжити?",
        requestFailed: "Помилка при відправці запиту",
        accessGranted: "Доступ надано",
        accessRejected: "Запит відхилено",
        noRequests: "Немає запитів",
        noClientNotes: "Приміток ще немає",
        noteDeletionRequestSent: "Запит на видалення надіслано адміністратору",
        noteDeletionRequestPending: "Запит на видалення цієї примітки вже надіслано",
        noteDeletionApproved: "Примітку видалено",
        noteDeletionRejected: "Запит відхилено",
        noNoteDeletionRequests: "Немає запитів на видалення приміток",
        noMicrophoneAccess: "Доступ до мікрофону заборонено",
        audioRecordTooShort: "Запис занадто короткий, нічого не було завантажено.",
        orderCuttingDone: "Завершено!",
        orderSentToCutting: "Відправлено!",
        statusUpdated: "Статус оновлено",
        statusCreated: "Статус створено",
        noManagersOnline: "Немає менеджерів онлайн",
        noDraftsmenOnline: "Немає складальників онлайн",
        fileDeleted: "Файл {name} успішно видалено",
        isUrgent: "Замовлення термінове",
        uploadedFiles: "Завантажено файлів",
        uploadedImages: "Завантажено картинок",
        deleteClientMsg: "Ви дійсно бажаєте видалити клієнта",
        successfullyDeleteClientMsg: "Клієнта видалено успішно",
        errorDeleteClient: "Помилка при видаленні клієнта",
        clientHasOrders: "Клієнт має замовлення, видалення не можливе!",
        cutDeleted: "Відрізок видалено",
        confirmDeleteOrderPt1: "ви дійсно бажаєте видалити замовлення",
        confirmDeleteOrderPt2: "Це видалить всі пов'язані з ним дані",
        userDeleted: "Користувача успішно видалено",
        onlyImageDownload: "Завантажити можна лише картинку!",
        fileTooLarge: "Розмір файлу перевищує допустимий ліміт",
        invalidFileType: "Недопустимий тип файлу",
        confirmImageDelete: "Ви впевнені, що хочете видалити зображення?",
        orderUpdated: "Замовлення успішно оновлено",
        orderCloned: "Замовлення успішно клоновано",
        noChanges: "Змін не було",
        noResults: "Нічого не знайдено. Спробуйте змінити запит.",
        firstSearchResults: "Показано перші 50 результатів. Продовжуйте писати для уточнення...",
        selectNoPatternsStatus: "Будь ласка, оберіть статус відсутності лекал."
    },
    modal: {
        chatErrorTitle: "Помилка чату",
        chatErrorText: "Не вдалося надіслати повідомлення. Схоже, стався збій з'єднання. Будь ласка, перезавантажте сторінку.",
        editStatus: "Редагувати статус",
        addStatus: "Додати статус",
        addOrder: "Додати замовлення",
        editOrder: "Редагування замовлення",
        inactivityTitle: "Ви ще тут?",
        inactivityText: "Ми помітили, що ви неактивні протягом 15 хвилин.",
        inactivitySubtext: "Якщо ви відійшли, будь ласка, встановіть відповідний статус, щоб ваші колеги були в курсі.",
    },
    months: {
        april: "Квіт",
        august: "Серп",
        december: "Груд",
        february: "Лют",
        january: "Січ",
        july: "Лип",
        june: "Черв",
        march: "Бер",
        may: "Трав",
        november: "Лист",
        october: "Жовт",
        september: "Вер"
    },
    navbar: {
        adminPanel: "Панель адміністратора",
        allOrderList: "Список всіх замовлень",
        mainPage: "Головна",
        myClients: "Мої клієнти",
        draftsmenStats: "Статистика складальників"
    },
    placeholders: {
        selectDraftsman: "Пошук складальника",
        search: "Пошук...",
        selectBrand: "Оберіть марку",
        selectModel: "Оберіть модель",
        selectYear: "Оберіть рік",
        recordingInProgress: "Йде запис...",
        DraftsManName: "Ім'я складальника",
        carBrandModel: "Марка та модель машини",
        clientName: "Iм'я клієнта",
        clientPhone: "Телефон клієнта",
        clientStatus: "Cтатус клієнта",
        clientNote: "Напр.: Завжди без поворотників",
        managerName: "Ім'я менеджера",
        orderDescription: "Опис замовлення",
        searchClientByName: "Пошук клієнта за іменем",
        searchUserByName: "Пошук користувача за іменем",
        selectClient: "Виберіть клієнта",
        selectFiles: "Виберіть файли",
        selectManager: "Виберіть менеджера",
        userLogin: "Логін користувача",
        userPassword: "Пароль користувача",
        writeMessage: "Напишіть повідомлення..."
    },
    ranges: {
        last7: "За 7 днів",
        thisMonth: "За поточний місяць",
        lastMonth: "За минулий місяць",
        thisYear: "За рік",
        allTime: "За весь час",
        today: "Сьогодні",
        yesterday: "Вчора"
    },
    tableheadings: {
        completedOrders: "Виконано",
        totalTime: "Час роботи",
        reprocessedOrders: "Перероблено",
        anomalies: "Аномалії",
        reprocessTime: "Час переробки",
        averageTime: "Середній час",
        longestTime: "Найдовший час",
        requests: "Запити дистриб'юторів",
        noteDeletionRequests: "Видалення приміток",
        noteDeletionHistory: "Історія видалених приміток",
        badges: "Баджі",
        actions: "Дії з статусом",
        color: "Колір",
        role: "Роль",
        statuses: "Список статусів",
        draftsman: "Складальник",
        distributor: "Дистриб'ютор",
        added: "Додано",
        client: "Клієнт",
        clients: "Клієнти",
        closed: "Закрито",
        completed: "Завершено",
        created: "Створено",
        date: "Дата",
        edited: "Змінено",
        history: "Історія",
        manager: "Менеджер",
        name: "Назва",
        note: "Примітка",
        notes: "Нотатки",
        status: "Статус",
        title: "Заголовок",
        type: "Тип",
        user: "Користувач",
        users: "Користувачі",
        all: "Усі",
        preview: "Попередній перегляд",
        table_actions: "Дії"
    },
    titles: {
        printImage: "Друк зображення",
        attentionNotes: "Увага! Тут примітки",
        mainNote: "Головна примітка"
    },
    statuses: {
        cutting: "Порізка викрійки",
        active: "Нове замовлення",
        closed: "Закрито",
        done: "Завершено",
        work: "В роботі",
        pending: "Очікує",
        approved: "Схвалено",
        rejected: "Відхилено"
    },
    auth: {
        loginLabel: "Ваш логін",
        loginRequired: "Напишіть логін",
        passwordLabel: "Пароль",
        passwordPlaceholder: "Напишіть ваш пароль",
        loginButton: "Увійти",
        loginNote: "Дані для входу можна отримати у адміністратора",
        registerTitle: "Реєстрація в системі",
        yourLoginLabel: "Ваш логін",
        usernamePlaceholder: "Придумайте логін",
        yourPasswordLabel: "Ваш пароль",
        passwordCreatePlaceholder: "Придумайте пароль",
        passwordConfirmLabel: "Підтвердіть пароль",
        passwordConfirmPlaceholder: "Повторіть пароль",
        registerButton: "Зареєструватись"
    },
    notifications: {
        order: "Замовлення",
        draftsman: "Викройщик",
        client: "Клієнт",
        manager: "Менеджер",
        audioMessage: "Голосове повідомлення",
        defaultTitle: "Повідомлення",
        testTitle: "Тест сповіщеннь",
        testText: "Тестове повідомлення!!!",
        newOrder: "Нове замовлення",
        assignedToOrder: "Вас призначено на замовлення",
        takenToWork: "Взято в роботу",
        orderDone: "Замовлення завершено",
        chatMessage: "Нове повідомлення в чаті",
        reminder: "У вас є не закриті замовлення. Змініть їх статус"
    },
    operations: {
        create: "Створення",
        update: "Оновлення",
        delete: "Видалення",
        get: "Отримання",
        getByType: "Отримання за типом",
        getByDate: "Отримання за датою",
        login: "Авторизація (вхід)",
        logout: "Вихід",
        upload: "Завантаження файлу",
        get_order: "Отримання даних замовлення",
        edit_order: "Редагування даних замовлення",
        error: "Помилка в системі",
    },
    time: {
        hours_short: "г",
        minutes_short: "хв",
        seconds_short: "с",
        minutes: "хвилини тому",
        minute: "1 хвилину тому",
        hours: "годин тому",
        hour: "1 годину тому",
        days: "дні тому",
        day: "1 день тому",
        weeks: "тижні тому",
        week: "1 тиждень тому",
        months: "міс тому",
        month: "1 міс тому"
    },
    log: {
        yes: "Так",
        no: "Ні",
        subcriptionUnsubscribe: "Підписка відмінена.",
        orderUrgent: "Замовлення термінове",
        orderNotUrgent: "Замовлення не термінове",
        notePrefix: "Примітка",
        noItems: "Не було",
        allCutsDeleted: "Видалено всі викрійки",
        fields: {
            title: "Назва",
            description: "Примітка",
            status: "Статус",
            isUrgent: "Терміновість",
            clientId: "Клієнт",
            managerId: "Менеджер",
            image: "Зображення",
            file: "Файли",
            cuts: "Відрізки плівки для замовлення",
            hasProblematicPattern: "Проблемна викрійка",
            hasProblematicPackaging: "Проблема упаковки",
            wasCut: "Лекало порізане",
            wasCutBadge: "Порізане",
            hasNoPatterns: "Немає лекал",
            noPatternsType: "Статус відсутності лекал",
            patternRequestSent: "Відправлено запит на отримання лекал",
            assemblyPrograms: "Програма збірки лекала"
        },
    },
    units: {
        m: "м"
    },
    logwords: {
        car: "Автомобіль",
        carBrand: "Марка авто",
        carModel: "Модель авто",
        carYear: "Рік випуску авто",
        user: "Користувач",
        order: "Замовлення",
        client: "Клієнт",
        file: "Файл",
        file_added: "Додано файл",
        deleted: "Видалено",
        added: "Додано",
        current: "Зображення, які вже були",
        existed: "Були фото",
        was: "Було:",
        became: "Стало:"
    },
    common: {
        crud:{
            titles: {
                list: 'Список {name}',
                create: 'Створити {name}',
                edit: 'Редагувати {name}',
                view: 'Перегляд {name}'
            }
        },

        created_success: '{name} успішно створено.',
        created_error: 'Помилка при створенні {name}.',

        updated_success: '{name} успішно оновлено.',
        updated_error: 'Помилка при оновленні {name}.',

        confirm_delete: 'Ви впевнені, що хочете видалити {name}?',
        deleted_success: '{name} успішно видалено.',
        deleted_error: 'Помилка при видаленні {name}.',

        load_error: 'Помилка при завантаженні {name}.'
    },
    validation: {
        required: 'Поле {field} є обов\'язковим.',
        email: 'Введіть правильний email.',
        min: 'Мінімальна довжина поля {field}: {min} символів.',
        max: 'Максимальна довжина поля {field}: {max} символів.',
        min_value: 'Значення поля {field} не може бути менше ніж {min}.',
        max_value: 'Значення поля {field} не може бути більше ніж {max}.',
        confirmed: 'Підтвердження поля {field} не співпадає.',
        numeric: 'Поле {field} повинно містити лише цифри.',
        string: 'Поле {field} повинно бути текстовим.',
        boolean: 'Поле {field} повинно бути true або false.',
        array: 'Поле {field} повинно бути масивом.',
        integer: 'Поле {field} повинно бути цілим числом.',
        date: 'Поле {field} повинно містити коректну дату.',
        url: 'Поле {field} повинно бути дійсним URL.',
        unique: 'Поле {field} повинно бути унікальним.',
        exists: 'Вибране значення для {field} недійсне.',
        digits: 'Поле {field} повинно містити {digits} цифр.',
        regex: 'Поле {field} має неправильний формат.',
        phone: 'Введіть коректний номер телефону.',
        same: 'Поля {field} і {other} повинні співпадати.',
        in: 'Невірне значення для {field}.',
        not_in: 'Значення для {field} не дозволене.',
        between: 'Поле {field} повинно бути між {min} і {max}.',
        file: 'Поле {field} повинно бути файлом.',
        mimes: 'Файл у полі {field} повинен бути типу: {types}.',
        size: 'Розмір файлу {field} повинен бути не більше {size} КБ.'
    },
    table: {
        placeholders: {
            empty_heading: 'Дані ще не додані.',
            empty_description: 'Як тільки дані будуть додані, вони відобразяться тут!'
        }
    },
    sso: {
        redirecting_title: "Перенаправлення...",
        redirecting_text: "Заходимо в Delivery CRM",
        error_title: "Помилка",
        error_text: "Не вдалося згенерувати посилання для входу. Спробуйте пізніше."
    },
    patterns: {
        databaseTitle: "База лекал",
        searching: "Шукаємо відповідні лекала...",
        openOnWebsite: "Відкрити \"{brand} {model}\" на сайті лекал",
        notFound: "На жаль, для цієї моделі та року лекал не знайдено.",
        viewPatterns: "Переглянути лекала",
        openOnSite: "Відкрити на сайті",
        backToCars: "Назад до списку авто",
        addedToCuts: "Це лекало додано до відрізків",
        cutId: "ID викрійки:",
        meter: "Метр"
    }
};